export const ShoppingCartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="17"
    fill="none"
    viewBox="0 0 15 17"
  >
    <g clip-path="url(#a)">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.059"
        d="M8.852 5.044v-2.44a1.931 1.931 0 0 0-3.86-.001v2.441m7.247 11.065H1.597a1.204 1.204 0 0 1-1.195-1.376l1.382-9.9a1.203 1.203 0 0 1 1.196-1.04h7.883c.604 0 1.114.442 1.196 1.04l1.382 9.9c.1.728-.46 1.376-1.196 1.376h-.006Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h14.122v16.495H0z" />
      </clipPath>
    </defs>
  </svg>
);
